import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ConversationVisibilityIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/conversation-visibility'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'conversation_visibility_settings',
          component: ConversationVisibilityIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
